import useAxios from 'hooks/useAxios'

export default function useSurveyQuestions(surveyToken) {
  const { data } = useAxios({
    url: surveyToken ? `dashboard/survey-builder/v2/${surveyToken}/` : null,
    skip: !surveyToken,
  })
  return (data && data.questions) || []
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useSurveyQuestions/index.js